import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import "./styles/indexPage.css"
import {
  Card,
  Button,
  Input,
  Select,
  Dropdown,
  Table,
  Icon,
  Dimmer,
  Loader,
} from "semantic-ui-react"
import { productListApi } from "../config/apiUrls"
import { apiGet } from "../utils/apiConnector"

const data = [
  {
    title: "Create an account",
    desc: "You've already done it! It remains to complete the initial setup",
    done: true,
  },
  {
    title: "Add your first SKU",
    desc: "Store all product information in one place",
    done: true,
  },
  {
    title: "Download the Android app",
    desc: "Prepare your products for loading into the system",
    done: true,
  },
  {
    title: "Print or request 'Marking' codes",
    desc:
      "To start using the system right away please use your printer to print test codes Soon we will provide the ability to do this remotely",
    done: true,
  },
]

const IndexPage = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const [isLoading, setIsLoading] = useState(false)
  const [products, setProducts] = useState([])
  const getProducts = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      setIsLoading(true)
      apiGet(productListApi + "/" + storeId, {})
        .onOk((res) => {
          console.log(res.data.response)
          setProducts(res.data.response)
        })
        .onFail(() => {})
        .afterAll(() => {
          setIsLoading(false)
        })
        .startSingle()
    }
  }
  useEffect(() => {
    // history.push("orders")
    getProducts()
    return () => {}
  }, [])
  return (
    <>
      <div>
        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
        <div style={{ marginTop: 70, marginLeft: 40, marginRight: 80 }}>
          <div>
            <h3>
              <b>{t("Welcome to the Marking system")}</b>
            </h3>
          </div>
          <div style={{ color: "gray" }}>
            {t("Follow these steps to get started")}.
          </div>
          <div>
            <Table style={{ border: "0px solid red" }}>
              <Table.Body>
                {data.map((q) => (
                  <>
                    <Table.Row>
                      <Table.Cell
                        style={{
                          border: "0px solid red",
                          backgroundColor: "#fafafa",
                          width: 100,
                        }}
                      >
                        <Icon
                          name={(q.done ? "check" : "remove") + " circle"}
                          color={q.done ? "green" : "red"}
                          size="large"
                        />
                      </Table.Cell>
                      <Table.Cell
                        style={{
                          border: "0px solid red",
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <div style={{ width: 400 }}>
                          <div>
                            <b>{t(q.title)}</b>
                          </div>
                          <div style={{ color: "gray", fontSize: 13 }}>
                            {t(q.desc)}
                          </div>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))}
                <Table.Row>
                  <Table.Cell
                    style={{
                      width: 100,
                      border: "0px solid red",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <div></div>
                  </Table.Cell>
                  <Table.Cell
                    style={{
                      border: "0px solid red",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <div
                      style={{
                        width: 400,
                        borderRadius: 8,
                        border: "1px solid lightgreen",
                        padding: 20,
                        height: 130,
                        display: products.length > 0 ? "none" : "flex",
                      }}
                    >
                      <div style={{ height: "100%", width: "60%" }}>
                        <div style={{ fontSize: 14 }}>
                          <b>{t("Add your first product")}</b>
                        </div>
                        <div style={{ fontSize: 13 }}>
                          {t("Make your product page available in real time")}
                        </div>
                      </div>
                      <div
                        style={{
                          height: "100%",
                          width: "40%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          content={t("Add")}
                          positive
                          onClick={() => {
                            history.push("/products")
                          }}
                        />
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>
    </>
  )
}

export default IndexPage
